import React, { useState, useEffect } from 'react';
import { ApiURLs } from '../../constant/ApiUrls';
import { fetchData, uploadImage, postData, updateData, deleteData } from '../../services/api';
import Paper from '@mui/material/Paper';
import Swal from 'sweetalert2';
import { DataGrid } from '@mui/x-data-grid';

import {
    Wrapper,
    Card
    , EditButton,

} from './car_review_styles';


import CarReviewSection from './CarReview';


import CarAddFeature from './CarAddFeature';


const CarReview = () => {
    const [aboutUs, setAboutUS] = useState(null);
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [editAboutUS, setEditAboutUS] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        link:'',
        description: '',
        image: null,
        image_uploaded: null,
    });
    const [formErrors, setFormErrors] = useState({});

    const [activeTab, setActiveTab] = useState('about');

    const getAboutUsData = async ({ load = true } = {}) => {
        if (load) {
            setLoading(true);
        }
        const url = `${ApiURLs.CARREVIEW}`;
        try {
            const response = await fetchData(url);
            if (response.status === 1 || response.status === 2) {
                setAboutUS(response);
                if (response.status === 2) {
                    setFormData({ title: '', description: '', image: null, link: '', image_uploaded:"" });
                }
                else {
                    setFormData({ title: response.data.title,link: response.data.link, image: null, image_uploaded: response.data.image });

                }

            } else {
                setAboutUS(null);
            }
        } catch (error) {
            console.error('Error fetching about us:', error);
            setAboutUS(null);
        } finally {
            setLoading(false);

        }
    };

    useEffect(() => {
        getAboutUsData();
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData({ ...formData, image: files[0] });
            setFormErrors({})
                ;
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("hdjhfdkjsjkdshkjfdhkjdhskjhfdshfkjdshfjsjhfh", aboutUs);



        if (aboutUs.status === 2) {

            const errors = {};
            if (!formData.image) {
                errors.image = 'Image is required';
            }
            if (!formData.title.trim()) {
                errors.title = 'Title is required';
            }
            // if (!formData.description.trim()) {
            //     errors.description = 'Description is required';
            // }

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }

            setButtonLoading(true);

            console.log('Submit formData:', formData);

            const uploadedImage = await uploadImage(
                ApiURLs.UPLOAD_IMAGE,
                "image",
                formData.image,
                "car_review"
            );
            console.log(`Upload image function response: ${JSON.stringify(uploadedImage)}`);



            console.log('Submit formData:', formData);

            const data = {
                ...formData,
                image: uploadedImage?.data?.file?.path || '',
            }
            console.log('DAATDATDTADA:::', data);

            await postData(data, `${ApiURLs.CARREVIEW}`);
            setButtonLoading(false);
            await getAboutUsData();

            setEditAboutUS(false);
        }
        else if (aboutUs.data.id) {

            console.log("hdjhfdkjsjkdshkjfdhkjdhskjhfdshfkjdshfjsjhfh");

            const errors = {};

            if (!formData.title.trim()) {
                errors.title = 'Title is required';
            }
            // if (!formData.description.trim()) {
            //     errors.description = 'Description is required';
            // }

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }

            setButtonLoading(true);

            console.log('Submit formData:', formData);

            let uploadedImage;
            if (formData.image) {
                uploadedImage = await uploadImage(
                    ApiURLs.UPLOAD_IMAGE,
                    "image",
                    formData.image,
                    "car_review"
                );
            }

            console.log(`Upload image function response: ${JSON.stringify(uploadedImage)}`);



            console.log('Submit formData:', formData);

            const data = {
                ...formData,
            }

            if (uploadedImage) {

                data['image'] = uploadedImage?.data?.file?.path || '';

            }


            console.log('DAATDATDTADA:::', data);

            await updateData(data, `${ApiURLs.CARREVIEW}/${aboutUs.data.id}`);
            setButtonLoading(false);
            await getAboutUsData();
            setEditAboutUS(false);
        }


    };



    const paginationModel = { page: 0, pageSize: 10 };




    const featuresListingHeading = [
        {
            field: "id", headerName: "NO", width: 40,
            renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
        },


        {
            field: "title", headerName: "Title", width: 200,
            // renderCell: (params) => params.value, 
        },

        {
            field: "description", headerName: "Description", width: 400,
            // renderCell: (params) => params.value, 
        },
        {
            field: "action",
            headerName: "Action",
            width: 300,
            sortable: false,
            renderCell: (params, row) => {
                console.log("veiw is called", params, row);


                return (
                    <div style={{
                        display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
                        height: "100%"
                    }}>


                        <CarAddFeature buttonLabel={"Edit Feature"} editMode={true}
                            handleAddFeature={handleEditFeature}
                            memberData={params.row}

                        />

                        <button
                            onClick={() => handleDeleteF(params.row)}
                            style={{
                                backgroundColor: "#F44336",
                                color: "white",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: "4px",
                                fontSize: "10px",
                                width: "30%",
                                height: "24px",  // Increased height
                                padding: "2px 5px", // Added padding
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            Delete
                        </button>


                    </div>

                );
            },
        },


    ];


    const handleDeleteF = (row) => {
        console.log("Deleting Team Mamber ID:", row);
        Swal.fire({
            title: ``,
            html:
                "" +
                "Are you sure?" +
                "<br>" +
                `You want to Delete "${row.title}"`,
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: `Yes, Delete`,
            showCloseButton: true,
            cancelButtonColor: "gray",
            confirmButtonColor: "#4f83df",
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                handleDeleteFeature(row.id,)
            }
        });

        // Add your delete logic here
    };

    const handleAddFeature = async (d) => {

        setLoading(true);
        console.log("Received data:", d);
        // const uploadedImage = await uploadImage(
        //     ApiURLs.UPLOAD_IMAGE,
        //     "image",
        //     d.uploadImage,
        //     "car_review"
        // );


        const data = {
            ...d,
            // icon: uploadedImage?.data?.file?.path || '',
            parent_id: aboutUs.data.id,
        }

        console.log('DAATDATDTADA:::', data);

        await postData(data, `${ApiURLs.CARREVIEWFEATURE}`);

        await getAboutUsData();

    };


    const handleEditFeature = async (d) => {

        setLoading(true);
        console.log("Received data:", d);





        const data = {
            ...d,
        }

        // if (uploadedImage) {
        //     data['image'] = uploadedImage?.data?.file?.path || '';

        // }
        console.log('DAATDATDTADA:::', data);

        await updateData(data, `${ApiURLs.CARREVIEWFEATURE}/${data.id}`);

        await getAboutUsData();

    };


    const handleDeleteFeature = async (id) => {

        setLoading(true);

        await deleteData(`${ApiURLs.CARREVIEWFEATURE}/${id}`);

        await getAboutUsData();

    };


















    return (
        <div>
            <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
                <button
                    onClick={() => setActiveTab('about')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'about' ? '#007bff' : '#eee',
                        color: activeTab === 'about' ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    
                        Featured Car Review
                </button>
                <button
                    onClick={() => setActiveTab('feature')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'feature' ? '#007bff' : '#eee',
                        color: activeTab === 'feature' ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Feature
                </button>
            </div>

            <Wrapper>
                <Card isFixedWidth={aboutUs?.status === 2} isPadding={activeTab === "about"}>

                    {activeTab === "about" && aboutUs?.status === 1 && loading === false && editAboutUS===false && (
                        <EditButton onClick={() => setEditAboutUS(true)}>Edit</EditButton>
                    )}

                    {activeTab === "about" ? <CarReviewSection
                        loading={loading}
                        aboutUs={aboutUs}
                        editAboutUS={editAboutUS}
                        formData={formData}
                        formErrors={formErrors}
                        buttonLoading={buttonLoading}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                    /> : <Paper sx={{ height: "95%", width: '100%' }}>



                            {aboutUs?.data?.id && <div style={{ padding: "10px", justifyItems: "end" }}>
                                <CarAddFeature buttonLabel={"Add Feature"} handleAddFeature={handleAddFeature}
                                />
                            </div>}

                            <DataGrid
                                rows={aboutUs?.data?.features || []}
                                columns={featuresListingHeading || []}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[10, 25]}
                                rowHeight={80}
                                loading={loading}
                                checkboxSelection={false}
                                sx={{ border: 0 }}
                            />


                        </Paper>
                    }


                </Card>
            </Wrapper>
        </div>

    );
};



export default CarReview;
